import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import Typography from '@mui/material/Typography';

/*position alternate left o right*/

const TimelineWork = () => {
  return (
    <Timeline position="right">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          sept 2022 - actualidad
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
          <Typography variant="h5" component="span">
            Full-Stack Developer
          </Typography>
          <Typography><b>Acevedo</b></Typography>
          <Typography>Desarrollo de aplicaciones web cloud native con Angular, Node.js, Express, MongoDB... Herramientas de despliegue como Docker. Control de ramas, versiones y repositorios.</Typography>
        </TimelineContent>
      </TimelineItem>
      
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          jun 2019 - aug 2019
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
        <Typography variant="h5" component="span">
            Técnico de Soporte IT
          </Typography>
          <Typography><b>Colegio de Registradores de España</b></Typography>
          <Typography>Soporte técnico de programas (Deposito digital D2, Legalia, Internet Explorer, Java) y funcionamiento del portal.</Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: 'auto 0' }}
          variant="body2"
          color="grey"
        >
          mar 2019 - jun 2019
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2 }}>
        <Typography variant="h5" component="span">
            Técnico informático
          </Typography>
          <Typography><b>Serconi</b></Typography>
          <Typography>Soporte remoto. Resolver problemas informáticos, optimización, políticas de gestión de ficheros...</Typography>
        </TimelineContent>
      </TimelineItem>

    </Timeline>
  );
}

export default TimelineWork